// @ts-ignore
import Lottie from "react-lottie";
import "./Loading.scss";
import lottieIcon from "../../assets/loading-cards.json";

export const LoadingCards = () => {
  return (
    <div className="loading">
      <Lottie
        height={200}
        width={200}
        options={{
          loop: true,
          autoplay: true,
          animationData: lottieIcon,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
      />
    </div>
  );
};
